var $ = require('jquery');

$(function () {
    $('.stats-grid-card-col').each(function (i) {
        if ($(window).width() > 991) {
            $(this).css({ animationDelay: i + 1 + 's' });
        }
    });
});
